import { Navigate } from "react-router-dom";
import { useSuperAdmin } from "./SuperAdminContext";

export default function ProtectedSuperAdminRoute({ children }) {
  const { superAdmin, loading } = useSuperAdmin();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen bg-[#f9fafb]">
        <div className="flex flex-col items-center gap-3">
          <div className="w-8 h-8 border-2 border-gray-200 border-t-[var(--k-green)] rounded-full animate-spin" />
          <p className="text-sm text-gray-400">Vérification de la session...</p>
        </div>
      </div>
    );
  }

  if (!superAdmin) return <Navigate to="/superadmin/login" replace />;

  return children;
}
